<template>
    <div class="login">
        <div style="height:25%"></div>
        <div class="content">
            <div class="left">
                <div class="logo"><img src="../../assets/img/login/company_logo.png" style="padding-top:10px;"/></div>
                <div class="font">
                    <div>龙星ERP5.0系统</div>
                    <div>C-Star Enterprise Resource Planning</div>
                </div>
            </div>
            <div class="right">
                <el-form :model="ruleForm" status-icon ref="ruleForm" class="demo-ruleForm" label-width="auto" inline=false>
                    <el-form-item :label="$t('getapi[7981]')">
                        <el-select v-model="ruleForm.instanceName" :placeholder="$t('getapi[12266]')" class="select">
                            <el-option v-for="item in apiData" :key="item.Login_Name" :label="item.Login_Name"
                                       :value="item.Login_Name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('getapi[7982]')" prop="Username">
                        <el-input v-model="ruleForm.userName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('getapi[7983]')" prop="Password">
                        <el-input type="password" v-model="ruleForm.password"
                                  @keyup.enter.native="checkLoginErrorTimes()"></el-input>
                        <span class="wjmm" v-if="czmm" @click="sendMsg">{{$t('getapi[12496]')}}</span>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="inorout" @change="changeLoginUrl" style="margin-left: 40px"></el-checkbox>
                        <span style="font-family: PingFangSC-Medium;font-size: 12px;color: #C0C5C8;text-align: left;">{{$t('getapi[12267]')}}</span>
                        <el-button type="primary" @click="checkLoginErrorTimes()" :loading="btns" :disabled="btns" style="margin-left: 8px">
                            {{$t('getapi[7]')}}
                        </el-button>
                    </el-form-item>
                </el-form>
                <el-dropdown class="international" @command="handleCommand">
					<span class="el-dropdown-link" style="color: #FFF0FF;">
						{{expLanguage(language)}}
						<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :disabled="language === 'zh'" command="zh">中文</el-dropdown-item>
                        <el-dropdown-item :disabled="language === 'en'" command="en">English</el-dropdown-item>
                        <el-dropdown-item :disabled="language === 'id'" command="id">id</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-checkbox v-model="checked"></el-checkbox>
                <span style="font-family: PingFangSC-Medium;font-size: 12px;color: #C0C5C8;text-align: left;">{{ $t('getapi[7984]') }}</span>
            </div>
        </div>

        <el-dialog v-dialogDrag :visible.sync="vis" width="350px" top="17%" :close-on-click-modal="false">
            <slide-verify
                    ref="slideblock"
                    @fulfilled="onFulfilled"
                    @success="onSuccess"
                    @fail="onFail"
                    @refresh="onRefresh"
                    :accuracy="accuracy"
                    :slider-text="text"
                    :imgs="imgs"
            ></slide-verify>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visSendMsg" :title="$t('getapi[3545]')" width="300px" top="17%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div>
                <table>
                    <tr>
                        <td>{{$t('getapi[12510]')}}</td>
                        <td><el-input v-model="PhoneNumber" type="text" size="mini" ></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visSendMsg = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" :disabled="!btn.sendMsg" @click="confirmSendMsg">{{sendMessage}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import axios from 'axios';
    import SIdentify  from '@/components/model/identify'
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js'
    import {
        Message,
        MessageBox
    } from 'element-ui';
    import img0 from '../../assets/img/verify/img.jpg';
    import img1 from '../../assets/img/verify/img1.jpg';
    import img2 from '../../assets/img/verify/img2.jpg';
    import img3 from '../../assets/img/verify/img3.jpg';
    import img4 from '../../assets/img/verify/img4.jpg';
    import img5 from '../../assets/img/verify/img5.jpg';
    export default {
        name: 'Login',
        data() {
            return {
                language: window.localStorage.getItem('lang'),
                ruleForm: {
                    instanceName: '',
                    userName: '',
                    password: '',
                },
                btns: false,
                apiData: [], // 登录实例数组,
                checked: true,
                inorout: true, //是否内网登录
                ip: '',
                vis: false,
                isVerify: false,
                accuracy: 2, // 滑块精度
                text: '向右滑动->',
                imgs: [
                    img0,
                    img1,
                    img2,
                    img3,
                    img4,
                    img5,
                ],
                czmm: false,
                visSendMsg: false,
                PhoneNumber: '',
                sendMessage:this.$t('getapi[12511]'),
                countdown: 60,
                btn:{
                    sendMsg: true
                }
            };
        },
        mounted: function () {
            let that = this
            this.getUrl()
            /*console.log('IP地址' + sessionStorage.getItem('ip'))*/
        },
        methods: {
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            },
            // 获取当前访问地址
            getUrl(){
                let that = this
                let url = window.location.href
                if(url.indexOf("192.168.") != -1 || url.indexOf('localhost') != -1){
                    sessionStorage.setItem('loginurl', Common.InUrl)
                    Common.Url = Common.InUrl
                    // Common.Url ='http://localhost:9091/'
                    that.inorout = true
                } else {
                    sessionStorage.setItem('loginurl', Common.OutUrl)
                    Common.Url = Common.OutUrl
                    that.inorout = false
                }
                if(url.indexOf("192.168.1.186") != -1 || url.indexOf('localhost') != -1 || url.indexOf('47.100.58.231') != -1 || url.indexOf('well-tech-china') != -1){
                    that.czmm = true
                } else {
                    that.czmm = false
                }
                that.getApiData()
            },
            // 根据下拉框的中被选中的值切换语言
            handleCommand(key) {
                this.language = key;
                this.$i18n.locale = key; //
                if(this.$limits.fnIsEmpty(this.language)){
                    this.language='zh';
                }
                window.localStorage.setItem('lang', this.language);
            },
            checkLoginErrorTimes(){
                let that = this
                that.instancename = that.ruleForm.instanceName;
                that.username = that.ruleForm.userName;
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.userpwd = encryptDes(that.ruleForm.password, key);
                let LoginDB = '';
                let LoginGroup = '';
                for (let i = 0; i < that.apiData.length; i++) {
                    if (that.instancename === that.apiData[i]['Login_Name']) {
                        LoginDB = that.apiData[i]['Login_DB'];
                        LoginGroup = that.apiData[i]['Login_Group'];
                        break;
                    }
                }
                let data = {
                    SysName: 'ERP',
                    Login_DB: LoginDB,
                    Login_Group: LoginGroup,
                    Login_DB_View: that.instancename,
                    Login_Code: that.username,
                    Login_Pwd: that.userpwd,
                };
                axios
                    .post(Common.Url + 'User/SYS_Users/CheckLoginErrorTimes', data)
                    .then(function (res) {
                        let reqdata = res.data;
                        if (reqdata.Success == 1) {
                            if(reqdata.Key == 0 || (reqdata.Key > 0 && that.isVerify == true)){
                                that.submitForm(0)
                            } else {
                                that.vis = true
                                that.$nextTick(() => {
                                    that.onRefresh()
                                })
                            }
                        } else if(reqdata.Success == 2){
                            that.$message.error(that.$processdata.explainCallbackMsg(reqdata.Msg));
                        } else {
                            that.$message.error(that.$processdata.explainCallbackMsg(reqdata.Msg));
                            that.btns = false;
                        }
                        that.btns = false;
                    })
                    .catch(function (error) {
                        that.$message.error('错误提示: ' + error);
                        that.btns = false;
                    });
            },
            submitForm(val){
                let that = this;
                that.btns = true;
                that.instancename = that.ruleForm.instanceName;
                that.username = that.ruleForm.userName;
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.userpwd = encryptDes(that.ruleForm.password, key);
                if (that.checked !== true) {
                    that.$message.warning(this.$t('getapi[12269]'));//'请同意企业资源服务系统服务协议'
                    that.btns = false;
                    return false;
                }
                if (that.instancename == null || that.instancename == '') {
                    that.$message.warning(this.$t('getapi[12270]'));
                    that.btns = false;
                    return false;
                } else if (that.username == null || that.username == '') {
                    that.$message.warning(this.$t('getapi[12271]'));//'请输入用户账号'
                    that.btns = false;
                    return false;
                } else if (that.userpwd == null || that.userpwd == '') {
                    that.$message.warning(this.$t('getapi[899]'));//'请输入密码'
                    that.clicks = false;
                    return false;
                } else {
                    let LoginDB = '';
                    let LoginGroup = '';
                    for (let i = 0; i < that.apiData.length; i++) {
                        if (that.instancename === that.apiData[i]['Login_Name']) {
                            LoginDB = that.apiData[i]['Login_DB'];
                            LoginGroup = that.apiData[i]['Login_Group'];
                            break;
                        }
                    }
                    
                    // let url = window.location.hostname
                    let ip =  window.location.hostname
                    
                    let data = {
                        SysName: 'ERP',
                        Login_DB: LoginDB,
                        Login_Group: LoginGroup,
                        Login_DB_View: that.instancename,
                        Login_Code: that.username,
                        Login_Pwd: that.userpwd,
                        LangType: that.$processdata.getLang(),
                        IP_Address: ip,
                        IsDelFirstLogin: val,
                    };
                    axios
                        .post(Common.Url + 'User/SYS_Users/Login', data)
                        .then(function (res) {
                            let reqdata = res.data;
                            if (reqdata.Success == 1) {
                                // console.log("登录返回数据:"+reqdata.Msg);
                                let userdata = {
                                    username: reqdata.Login_Name,
                                    plv1: reqdata.P_LV1,
                                    plv2: reqdata.P_LV2,
                                    plv3: reqdata.P_LV3,
                                    plv4: reqdata.P_LV4,
                                    token: reqdata.Token,
                                    Login_DB: LoginDB,
                                    Login_Group: LoginGroup,
                                    Login_Code: that.username,
                                    Login_Pwd: that.userpwd,
                                    Company_Name: reqdata.Company_Name,
                                    Login_Instance: reqdata.Login_Instance,
                                    inner_flag: reqdata.inner_flag,
                                    EmpCode: reqdata.EmpCode,
                                    downxlsfile:reqdata.downxlsfile,
                                };
                                sessionStorage.setItem('userData', JSON.stringify(userdata));
                                if(reqdata.P_LV2.substr(577 - 1, 1) == 2){
                                    if(reqdata.MList){
                                        for(let i = 0;i<reqdata.MList.length;i++){
                                            reqdata.MList[i].User_Login_Pwd = encryptDes(reqdata.MList[i].User_Login_Pwd, key)
                                        }
                                        sessionStorage.setItem('dbinfo', JSON.stringify({
                                            ismultipleDB: 1,
                                            DBinfo:reqdata.MList
                                        }))
                                    }
                                } else {
                                    sessionStorage.setItem('dbinfo', JSON.stringify({
                                        ismultipleDB: 0,
                                        DBinfo:[]
                                    }))
                                }
                                that.$router.push({path: '/home'});
                            } else if(reqdata.Success == 2){
                                let userdata = {
                                    username: reqdata.Login_Name,
                                    plv1: reqdata.P_LV1,
                                    plv2: reqdata.P_LV2,
                                    plv3: reqdata.P_LV3,
                                    plv4: reqdata.P_LV4,
                                    token: reqdata.Token,
                                    Login_DB: LoginDB,
                                    Login_Group: LoginGroup,
                                    Login_Code: that.username,
                                    Login_Pwd: that.userpwd,
                                    Company_Name: reqdata.Company_Name,
                                    Login_Instance: reqdata.Login_Instance,                                    
                                    inner_flag: reqdata.inner_flag,
                                    EmpCode: reqdata.EmpCode,
                                    downxlsfile:reqdata.downxlsfile,
                                };
                                sessionStorage.setItem('userData', JSON.stringify(userdata));
                                if(reqdata.P_LV2.substr(577 - 1, 1) == 2){
                                    if(reqdata.MList){
                                        for(let i = 0;i<reqdata.MList.length;i++){
                                            reqdata.MList[i].User_Login_Pwd = encryptDes(reqdata.MList[i].User_Login_Pwd, key)
                                        }
                                        sessionStorage.setItem('dbinfo', JSON.stringify({
                                            ismultipleDB: 1,
                                            DBinfo:reqdata.MList
                                        }))
                                    }
                                } else {
                                    sessionStorage.setItem('dbinfo', JSON.stringify({
                                        ismultipleDB: 0,
                                        DBinfo:[]
                                    }))
                                }
                                that.$router.push({path: '/home'});
                                MessageBox.alert(that.$processdata.explainCallbackMsg(reqdata.Msg), that.$t('getapi[194]'), {
                                    confirmButtonText: that.$t('getapi[1146]'),
                                });
                            } else if(reqdata.Success == 3){
                                that.$confirm(
                                    that.$t('getapi[13118]'), that.$t('getapi[194]'), {
                                    confirmButtonText: that.$t('getapi[1146]'),
                                    cancelButtonText: that.$t('getapi[2054]'),
                                    type: 'warning'
                                })
                                .then(() => {
                                    that.submitForm(reqdata.Success);
                                })
                                .catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: that.$t('getapi[6096]')
                                    });
                                });                                
                            }
                            else {
                                that.$message.error(that.$processdata.explainCallbackMsg(reqdata.Msg));
                                that.isVerify = false
                                that.btns = false;
                            }
                            that.btns = false;
                        })
                        .catch(function (error) {
                            that.$message.error('错误提示: ' + error);
                            that.btns = false;
                        });
                    /* $.ajax({
                  url: Common.Url+'User/SYS_Users/Login',
                  type: 'post',
                  data: JSON.stringify(data),
                  contentType: 'application/json',
                  success: function (res) {
                    if(res.Success == 1) {
                      let userdata = {
                        username: res.Login_Name,
                        authority: res.P_LV1,
                        token: res.Token,
                        Login_DB: LoginDB,
                        Login_Group: LoginGroup,
                        Login_Code: that.username,
                        Login_Pwd: that.userpwd
                      }
                      sessionStorage.setItem('userData', JSON.stringify(userdata))
                      that.$router.push({path:'/homes'})
                    } else {
                      that.$message.error(res.Msg)
                    }
                  },
                  error: function(xhr, errorType, error) {
                    that.$message.error('Ajax request error, errorType: ' + errorType +  ', error: ' + error)
                  }
                }); */
                }
            },
            // 获取登录实例
            getApiData() {
                let that = this;
                axios
                    .post(Common.Url + 'Basic/GetApiData', {})
                    .then(function (res) {
                        let reqdata = res.data;
                        that.apiData = reqdata.DataContent;
                    })
                    .catch(function (error) {
                        that.$message.error('错误提示: ' + error);
                    });
                /* $.ajax({
                    url: Common.Url + 'Basic/GetApiData ',
                    type: 'post',
                    data: '',
                    contentType: 'application/json',
                    success: function(res) {
                        that.apiData = res.DataContent;
                    },
                    error: function(xhr, errorType, error) {
                        that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                }); */
            },
            changeLoginUrl(val) {
                let that = this
                if(val == true){
                    sessionStorage.setItem('loginurl', Common.InUrl)
                    Common.Url = Common.InUrl
                    // Common.Url ='http://localhost:9091/'
                    // Common.Url ='http://localhost:8014/'
                } else {
                    sessionStorage.setItem('loginurl', Common.OutUrl)
                    Common.Url = Common.OutUrl
                }
                console.log(val)
            },
            onSuccess(){
                let that = this
                that.vis = false
                that.isVerify = true
                that.submitForm(0);
            },
            onFail(){
                console.log('验证不通过');
            },
            onRefresh(){
                let that = this
                console.log('点击了刷新小图标');
                that.$refs.slideblock.reset()
            },
            onFulfilled() {
                console.log('刷新成功啦！');
            },
            expLanguage(val){
                if(val == 'zh'){
                    return '中文'
                } else if(val == 'en'){
                    return 'English'
                } else if(val == 'id'){
                    return 'id'
                } else {
                    return '中文'
                }
            },
            sendMsg(){
                let that = this
                that.visSendMsg = true
            },
            confirmSendMsg(){
                let that = this
                that.btn.sendMsg = false
                let auth_timer = setInterval(()=>{  //定时器设置每秒递减
                    that.countdown--;        //递减时间
                    that.sendMessage = this.$t('getapi[12511]') + "("+that.countdown+")"
                    if(that.countdown<=0){
                        that.btn.sendMsg = true;
                        that.sendMessage = this.$t('getapi[12511]')
                        clearInterval(auth_timer)
                    }
                },1000)
                let LoginDB = '';
                let LoginGroup = '';
                let ip =  window.location.hostname
                that.instancename = that.ruleForm.instanceName;
                that.username = that.ruleForm.userName;                
                for (let i = 0; i < that.apiData.length; i++) {
                    if (that.instancename === that.apiData[i]['Login_Name']) {
                        LoginDB = that.apiData[i]['Login_DB'];
                        LoginGroup = that.apiData[i]['Login_Group'];
                        break;
                    }
                }
                let data = {
                    Login_DB: LoginDB,
                    Login_Group: LoginGroup,
                    Login_Code:that.username,
                    IP_Address:ip,
                    PhoneNumber: that.PhoneNumber
                }
                axios
                    .post(Common.Url + 'User/SYS_Users/ResetPassword', data)
                    .then(function (res) {
                        let reqdata = res.data;
                        if (reqdata.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(reqdata.Msg));
                            that.visSendMsg = false
                        }else {
                            that.$message.error(that.$processdata.explainCallbackMsg(reqdata.Msg));
                        }
                    })
                    .catch(function (error) {
                        that.$message.error('错误提示: ' + error);
                        that.btns = false;
                    });
            },
        }
    };
</script>

<style scoped lang="less">
    // @import url('../../assets/css/common.css');
    @import url('../../assets/css/login.less');
    /deep/.el-input__inner{
        width:100%
    }
    /deep/.el-input {
        width: 100%;
    }
    /deep/input{
        height: 25px !important;
    }
    /deep/.select{
        input{
            height:27px !important;
        }
    }
    /deep/.el-dialog__body{
        padding:20px 20px !important
    }
    .wjmm{
        font-family: PingFangSC-Medium;font-size: 12px;color: #C0C5C8;float: right;
    }
    .wjmm:hover{
        font-family: PingFangSC-Medium;font-size: 12px;color: #E4393C;float: right;text-decoration:underline;text-decoration-color: #E4393C
    }
</style>
